
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
// Route
import { RouteConsts } from '@/routes/route';
// Components
import BaseComponent from './BaseComponent.vue';

import CookieConsent from 'vue-cookieconsent-component';
import 'vue-cookieconsent-component/src/scss/_cookie-consent.scss';
import 'vue-cookieconsent-component/src/scss/_cookie-consent-bottom.scss';
import 'vue-cookieconsent-component/src/scss/_cookie-consent-transition.scss';

/**
 * フッターコンポーネント
 */
@Component({
  components: {
    'cookie-consent': CookieConsent
  }
})
export default class Footer extends Mixins<BaseComponent>(BaseComponent) {
  // チュートリアルページ画面遷移
  private goToTutorialsPage() {
    this.$router.push({
      name: RouteConsts.TutorialsPage
    });
  }

  // 利用規約画面遷移
  private goToTermsPage() {
    this.$router.push({
      name: RouteConsts.TermsPage
    });
  }

  // 情報セキュリティポリシー画面遷移
  private goToSecurityPolicyPage() {
    // ３月末対応
    window.open('https://www.monet-technologies.com/security/');
    // this.$router.push({
    //   name: RouteConsts.SecurityPolicyPage
    // });
  }

  // プライバシーポリシー画面遷移
  private goToPrivacyPolicyPage() {
    // ３月末対応
    window.open('https://www.monet-technologies.com/privacy/');
    // this.$router.push({
    //   name: RouteConsts.PrivacyPolicyPage
    // });
  }

  // 特定商取引画面遷移
  private goToAsctPolicyPage() {
    this.$router.push({
      name: RouteConsts.AsctPolicyPage
    });
  }

  // お問い合わせ画面遷移
  private goToSupportPage() {
    this.$router.push({
      name: RouteConsts.SupportPage
    });
  }
}
